// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1uWe_","list":"BalanceDue_list__1-nWw","listRow":"BalanceDue_listRow__1Boin","total":"BalanceDue_total__2ShL6"};